<template>
  <div class="normal-sidebar" @click="$emit('click')">
    <div class="normal-sidebar__group-menu--wrapper">
      <div
        v-for="(group, groupIndex) in sidebarGroupItems"
        :key="group.key"
        class="normal-sidebar__group-menu"
      >
        <div v-if="group.divider && groupIndex > 0" class="divider-wrapper">
          <div class="divider" />
        </div>

        <div
          v-if="group.title"
          class="normal-sidebar__group-menu__header tamara-english-tag-2"
        >
          {{ group.title }}
        </div>
        <SidebarItem
          v-for="route in group.routes"
          :key="route.path"
          :is-collapsed="isCollapsed"
          :item="route"
          :base-path="route.path"
          :is-kyc-user="isKycUser"
          @click:arrow="handleClickArrow"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BUSINESS_LENDING_SIDEBAR_FEATURE_FLAG } from '@/constants/business-lending'
import { getABTProvider } from '@/plugins/abt/statsig'

const isBusinessLendingSidebarHidden = () => {
  const abtProvider = getABTProvider()

  return !abtProvider.isFeatureEnabled(BUSINESS_LENDING_SIDEBAR_FEATURE_FLAG)
}

const MENU_ITEMS_CONFIG = [
  {
    key: 'default',
    title: 'sidebar_group_title_orders',
    divider: false,
    routes: ['/dashboard', '/orders', '/dispute'],
  },
  {
    key: 'instore',
    title: 'sidebar_group_title_instore',
    divider: true,
    routes: ['/settings'],
  },
  {
    key: 'marketing',
    title: 'sidebar_group_title_marketing',
    divider: true,
    routes: ['/ads', '/deals'],
  },
  {
    key: 'payment',
    title: 'sidebar_group_title_payments',
    divider: true,
    routes: ['/settlement', '/invoices', '/transaction'],
  },
  {
    key: 'business-banking',
    title: 'sidebar_group_title_business_banking',
    divider: true,
    hidden: isBusinessLendingSidebarHidden,
    routes: [
      '/banking/dashboard',
      '/banking/transactions',
      '/banking/cards',
      '/capital',
    ],
  },
  {
    key: 'setting',
    title: 'sidebar_group_title_settings',
    divider: true,
    routes: ['/v2/profile', '/general-settings', '/users'],
  },
]

const _getRouteByBasePath = (sourceRoutes, basePath) =>
  sourceRoutes.find((route) => route.path === basePath)

export default {
  name: 'SidebarNormal',
  props: {
    subMerchantAccounts: {
      type: Array,
      default: () => [],
    },
    showSubMerchantAccounts: {
      type: Boolean,
      default: false,
    },
    merchantProfile: {
      type: Object,
      default: () => ({}),
    },
    subMerchants: {
      type: Array,
      default: () => [],
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    permissionRoutes: {
      type: Array,
      default: () => [],
    },
    isKycUser: {
      type: Boolean,
      default: false,
    },
    activeSubMerchantName: {
      type: String,
      default: '',
    },
  },
  computed: {
    sidebarGroupItems() {
      return MENU_ITEMS_CONFIG.filter(
        (menuGroup) => !this.shouldHideMenuGroup(menuGroup)
      )
        .map((menuGroup) => ({
          key: menuGroup.key,
          divider: menuGroup.divider,
          title: this.$te(menuGroup.title)
            ? this.$t(menuGroup.title)
            : menuGroup.title,
          routes: this.mapMenuGroupWithRoutes(menuGroup.routes),
        }))
        .filter((group) => group.routes.length > 0)
    },
  },
  methods: {
    shouldHideMenuGroup(menuGroup) {
      if (typeof menuGroup.hidden === 'function') {
        return menuGroup.hidden()
      }

      return !!menuGroup.hidden
    },
    mapMenuGroupWithRoutes(routes) {
      return routes
        .map((menuPath) => _getRouteByBasePath(this.permissionRoutes, menuPath))
        .filter((route) => !!route)
    },
    handleClickArrow(subMenuRef, path) {
      this.$emit('click:arrow', subMenuRef, path)
    },
  },
}
</script>

<style lang="scss" scoped>
.normal-sidebar {
  width: 100%;

  &__header-space {
    height: 18px;
  }

  &__group-menu {
    &__header {
      height: 20px;
      padding-inline: 16px;
      color: var(--tamara-color-content-low);
      text-align: start;
    }
  }
}
</style>
